import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  card: {
    width: theme.spacing(34),
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    height: '100%',
  },
  icon: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    color: theme.palette.header.main,
  },
  text: {
    marginTop: theme.spacing(2),
    fontSize: theme.spacing(3),
    color: theme.palette.header.main,
    textAlign: 'center',
  },
}));

const AdminCard = ({ name, icon, to, className }) => {
  const classes = useStyles();

  return (
    <div className={className}>
      <Card className={classes.card} square>
        <CardActionArea className={classes.content} href={to}>
          <CardMedia>{React.cloneElement(icon, { className: classes.icon })}</CardMedia>
          <CardContent>
            <Typography className={classes.text}>{name}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  );
};

export default AdminCard;
